import axios from "axios";
function movePage(x, y) {
    console.log(x, y);
    if (x == "forward") {
        if (y < this.offsets - 1) {
            this.curPage = this.curPage + 1;
            this.getDoggy(this.curPage * this.maxPerPage);
        } else {
            this.curPage = 0;
            this.getDoggy(this.curPage * this.maxPerPage);
        }
    } else {
        if (y > 0) {
            this.curPage = this.curPage - 1;
            this.getDoggy(this.curPage * this.maxPerPage);
        } else {
            this.curPage = this.offsets - 1;
            this.getDoggy(this.curPage * this.maxPerPage);
        }
    }
}
function getToken() {
    axios
        .get(
            "https://api.bscscan.com/api?module=stats&action=tokenCsupply&contractaddress=0x74926b3d118a63f6958922d3dc05eb9c6e6e00c6&apikey=" + process.env.VUE_APP_BSC
        )
        .then((response) => {
            console.log(response.data);
            var status = response.data.status;
            if (status == 1) {
                console.log(response.data.result);
                var temp = response.data.result;
                var res = temp.toString().substr(0, temp.toString().length - 18);
                this.tokensupply = Number(res).toLocaleString('en-US');
                console.log(res);
            } else {
                this.tokensupply = "API call exceeded :(";
            }
        })
        .catch((err) => {
            console.log(err);
            this.tokensupply = "Network Error [Happens to Brave Browser]";
        });
}
function getNFT() {
    axios
        .get(
            "https://api.bscscan.com/api?module=stats&action=tokenCsupply&contractaddress=0x2dca8804dca120085e9b511f18d8511f58faa64c&apikey=" + process.env.VUE_APP_BSC
        )
        .then((response) => {
            console.log(response.data);
            var status = response.data.status;
            if (status == 1) {
                console.log(response.data.result);
                var temp = response.data.result;
                this.nftminted = Number(temp).toLocaleString('en-US');
            } else {
                this.nftminted = "API call exceeded :(";
            }
        })
        .catch((err) => {
            console.log(err.message);
            this.nftminted = "Network Error [Happens to Brave Browser]";
        });
}
function getDoggyAttributes(nftid) {
    var nftid = parseInt(nftid);
    console.log(Number.isInteger(nftid));
    if (Number.isInteger(nftid)) {
        console.log("AAAAAA", nftid < 9999);
        if (nftid >= 0 && nftid <= 9999) {
            axios
                .get(
                    "https://www.bakeryswap.org/api/v2/nfts?nftType=104&offset=0&limit=50&sortName=price&sortBy=asc&onSale=-1&status=1&keyword=" +
                    nftid
                )
                .then((response) => {
                    console.log(response.data.data.list[0]);
                    this.dog = response.data.data.list[0].attributes;
                    this.dogimg = response.data.data.list[0].imageUrl;
                    this.dognftid = response.data.data.list[0].nftId;
                    this.dog["Accessory Type"] = this.dog.accessoryType;
                    this.dog["Collectible Value"] = this.dog.collectibleValue;
                    if(this.dog['avatar']){
                        delete this.dog.avatar;
                    }
                    delete this.dog.accessoryType;
                    delete this.dog.collectibleValue;
                });
        } else {
            alert("Enter a valid ID");
        }
    } else {
        alert("Enter a valid ID");
    }
}
function getDoggy(offset) {
    var offset = offset;
    axios
        .get(
            "https://www.bakeryswap.org/api/v2/nfts?nftType=104&offset=" +
            offset +
            "&limit=" +
            this.maxPerPage +
            "&sortName=price&sortBy=asc&onSale=1&status=1&keyword="
        )
        .then((response) => {
            //console.log(parseInt(response.data.data.count / 50));
            this.saleCount = response.data.data.count;
            this.doggys = response.data.data.list;
            //console.log(response.data.data.count);
            console.log(response.data.data.count);
            this.offsets = Math.ceil(response.data.data.count / this.maxPerPage);
            console.log(this.offsets);
        });
}
export { movePage, getToken, getNFT, getDoggyAttributes, getDoggy }